import React from 'react';
import './CalendarShimmer.css';

const WEEKDAY_COUNT = 7;
const DATE_CELL_COUNT = 42;

/** Placeholder shown while the desktop flight or hotel calendar chunk loads. */
class CalendarShimmer extends React.Component {
  renderMonth = (index) => (
    <div key={index} className="yovo-calendar-shimmer__month">
      <div className="yovo-calendar-shimmer__title" />
      <div className="yovo-calendar-shimmer__weekdays">
        {Array.from({ length: WEEKDAY_COUNT }, (_, day) => (
          <div key={day} className="yovo-calendar-shimmer__weekday" />
        ))}
      </div>
      <div className="yovo-calendar-shimmer__dates">
        {Array.from({ length: DATE_CELL_COUNT }, (_, day) => (
          <div key={day} className="yovo-calendar-shimmer__date" />
        ))}
      </div>
    </div>
  );

  render() {
    const months = this.props.months > 1 ? 2 : 1;
    return (
      <div
        className="yovo-calendar-shimmer"
        data-testid="calendar-shimmer"
        aria-hidden="true"
        aria-busy="true"
      >
        {Array.from({ length: months }, (_, index) => this.renderMonth(index))}
      </div>
    );
  }
}

export default CalendarShimmer;
